import { render, staticRenderFns } from "./ProjectsSprints.vue?vue&type=template&id=f7fc824a&scoped=true"
import script from "./ProjectsSprints.vue?vue&type=script&lang=js"
export * from "./ProjectsSprints.vue?vue&type=script&lang=js"
import style0 from "./ProjectsSprints.vue?vue&type=style&index=0&id=f7fc824a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fc824a",
  null
  
)

export default component.exports